import React, { useEffect, useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export default function BarChart(props) {
  const { data, title } = props;
  const chartComponentRef = useRef(null);

  const formatKey = key => key.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase());

  const getColor = value => {
    if (value > 66) {
      return '#22C55E';
    } else if (value > 33 && value <= 66) {
      return '#FFAB00';
    } else if (value <= 33) {
      return '#FF5630';
    }
    return '#22C55E';
  };

  const getActivityTitle = key => {
    switch (key) {
      case 'quiz_aulas':
        return 'Quizzes (aulas)';
      case 'quiz_guia':
        return 'Quizzes (guia)';
      case 'exercicios':
        return 'Exercícios';
      case 'desafios':
        return 'Desafios';
      default:
        return formatKey(key);
    }
  };

  const getAreaTitle = key => {
    switch (key) {
      case 'ciencias_natureza':
        return 'Ciências da Natureza';
      case 'ciencias_humanas':
        return 'Ciências Humanas e Soc. Aplicadas';
      case 'linguagens':
        return 'Linguagens e suas Tecnologias';
      case 'matematica':
        return 'Matemática';
      default:
        return formatKey(key);
    }
  };

  let formattedData;

  if (title === 'Desempenho por área de conhecimento') {
    formattedData = Object.entries(data || {})
      .filter(([_, value]) => value !== null)
      .map(([key, value]) => ({
        name: getAreaTitle(key),
        value: value?.percentage
      }));
  } else {
    formattedData = Object.entries(data || {})
      .filter(([_, value]) => value !== null)
      .map(([key, value]) => ({
        name: getActivityTitle(key),
        value: value
      }));
  }

  const series = [
    {
      name: 'Percentual médio',
      data: formattedData.map(item => ({
        y: item.value,
        color: getColor(item.value)
      }))
    }
  ];

  const namesArray = formattedData?.map(item => item.name);

  useEffect(() => {
    const handleResize = () => {
      if (chartComponentRef.current) {
        chartComponentRef.current.chart.reflow();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const options = {
    chart: {
      type: 'bar',
      height: 300
    },
    credits: {
      enabled: false
    },
    title: {
      text: title
    },
    legend: {
      enabled: false
    },
    xAxis: {
      categories: namesArray,
      title: {
        text: null
      },
      labels: {
        align: 'left',
        reserveSpace: true,
        style: {
          whiteSpace: 'nowrap',
          width: 112,
          textOverflow: 'ellipsis'
        }
      },
      gridLineWidth: 0,
      lineWidth: 0
    },
    yAxis: {
      title: {
        text: null
      },
      labels: {
        overflow: 'justify'
      },
      gridLineWidth: 0,
      lineWidth: 0,
      allowDecimals: false
    },
    series: series,
    plotOptions: {
      series: {
        borderRadius: 4,
        pointPadding: 0.5,
        groupPadding: 0.5,
        pointWidth: 30,
        pointHeight: 80
      }
    },
    pointWidth: 50
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      ref={chartComponentRef}
    />
  );
}
